import Vue from "vue";
import Router from "vue-router";
import {getPCorPhone} from "@/tools";



const setRoute = () => {
    if(getPCorPhone()){
        const index = resolve => require(["./pagesPhone/index.vue"], resolve);
        const cooperativeAlliance = resolve => require(["./pagesPhone/cooperativeAlliance.vue"], resolve);
        const about = resolve => require(["./pagesPhone/about.vue"], resolve);
        const service = resolve => require(["./pagesPhone/service.vue"], resolve);
        const solution = resolve => require(["./pagesPhone/solution.vue"], resolve);
        // const introduce = resolve => require(["./pagesPhone/introduce.vue"], resolve);
        return {
            index,
            cooperativeAlliance,
            about,
            service,
            solution
        }
    }else{
        const index = resolve => require(["./pages/index.vue"], resolve);
        const cooperativeAlliance = resolve => require(["./pages/cooperativeAlliance.vue"], resolve);
        const about = resolve => require(["./pages/about.vue"], resolve);
        const service = resolve => require(["./pages/service.vue"], resolve);
        const solution = resolve => require(["./pages/solution.vue"], resolve);
        const introduce = resolve => require(["./pages/introduce.vue"], resolve);
        return {
            index,
            cooperativeAlliance,
            about,
            service,
            solution,
            introduce
        }
    }
}


Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            component: setRoute().index,
            name: "index"
        },
        {
            path: "/index",
            component: setRoute().index,
            name: "index",
        },
        {
            path: "/about",
            component: setRoute().about,
            name: "about",
        },
        {
            path: "/service",
            component: setRoute().service,
            name: "service",
        },
        {
            path: "/solution",
            component: setRoute().solution,
            name: "solution",
        },
        {
            path: "/cooperativeAlliance",
            component: setRoute().cooperativeAlliance,
            name: "cooperativeAlliance",
        },
        // {
        //     path: "/introduce",
        //     component: setRoute().introduce,
        //     name: "introduce",
        // },
    ]
});
